export default class InputGetPeople
{
  constructor(pageNumber, resultsNumber, searchText, status, orderBy) 
  {
    this.pageNumber = pageNumber;
    this.resultsNumber = resultsNumber;
    this.searchText = searchText;
    this.status = status;
    this.orderBy = orderBy;
  }    
}